
import componentTitle from './_components/componentTitle.vue'
import {useStore} from "@/store";
import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";
interface State {
    configInfo: object[];
    baseInfo:  object[];
    photoList:  object[];
    templateCode: string;
}
export default defineComponent({
        name: "tocv3CarInfo",
        setup() {
            let state: State = reactive({
                configInfo: [],
                baseInfo: [],
                photoList: [],
                templateCode: ''
            })
            window.scrollTo(0,0);
            let carInfo = localStorage.getItem('carInfo') || '';
            console.log(carInfo);
            state.configInfo = JSON.parse(carInfo).configureInfos;
            state.baseInfo = JSON.parse(carInfo).basicItemInfos;
            
            return {
                state
            }
        },
        components: {
            componentTitle
        },
        beforeUnmount () {
            localStorage.removeItem('carInfo');
        },
    })
